<template>

	<div>
    <div class="lds-dual-ring dark" v-if="loading"></div>

		<div class="voucher" v-else>

          <div v-if="!display_count">
            <h2 :style="getStyle('h2')" v-html="config.sub_header_text"></h2>
          </div>

          <h2 :style="getStyle('h2')" v-if="!redeemed && display_count">Show this now!</h2>
          <h2 :style="getStyle('h2')" v-else-if="display_count">This code has been redeemed!</h2>
          <h2 :style="getStyle('h2')" v-else>Your voucher code</h2>
          <div :class="{redeemed:redeemed}" >
            <div v-if="code.qr_code">
              <img :src="code.qr_code" alt="voucher code" />
            </div>


            <span v-if="config.show_code != false" class=code :style="getStyle('code')" :class="{strike:redeemed}">{{code.uniquecode}}</span>

            <div class="button-wrapper" v-if="config.code_cta_link" >
              <a :href="`${config.code_cta_link+code.uniquecode}`"><button :style="{...getStyle('button'),minWidth:'187px'}">{{config.code_cta_text ? config.code_cta_text : 'Order and Pay Now'}}</button></a>
            </div>
            <p :style="getStyle('p')" v-if="config.udf_expiry_date">Expiry date: {{new Date(config.udf_expiry_date.replace(/-/g, "/")).toLocaleDateString()}}</p>

            <p :style="getStyle('p')" v-if="display_count">Activated {{redeemed_at.getHours()}}:<span v-if="redeemed_at.getMinutes() < 10" :style="getStyle('p')">0</span>{{redeemed_at.getMinutes()}} <br> {{redeemed_at.getDate()}}/{{redeemed_at.getMonth()+1}}/{{redeemed_at.getFullYear()}}</p>

            <div class="activate-steps" v-if="!display_count">
              <div class="step" v-for="(step, index) in config.how_to_use_steps">
                <div class="numberCircle" :style="getStyle('number-circle')">{{index+1}}</div>
                <p :style="getStyle('p')">{{step}}</p>
              </div>
              
              <div v-if="display_cta">
                <p v-if="typeof this.config.cta_upper_text !== 'undefined'"><small v-html="config.cta_upper_text"></small></p>
                <p><a :href="config.cta_link" target="_blank" class="button" :style="getStyle('button')">{{config.cta_text}}</a></p>
              </div>
            </div>


            <!-- COUNT DOWN -->
            <div v-if="display_count">
              <div class="count-down" :style="getStyle('button')">
                <span v-html="count"></span>
              </div>
            </div>
          </div>
          <p v-if="redeemed && ((config.contact_vouchers_amount) > 0)"><button v-on:click="$store.commit('SET_SCREEN','welcome')" target="_blank" class="button" :style="getStyle('button')">Show my next voucher</button></p>
    </div>

	</div>

</template>

<script>
export default {
  name: 'ActivateVoucher',
  props: {
    email: String
  },
  data : function(){       
    return {
      code :false,
      redeemed_at:false,
      redeemed:false
    }
  },
  computed: {
      config(){
          return this.$store.getters.getCamapignConfig;
      },

      loading(){
          return this.$store.getters.getAppLoading;
      },

      apiCampaignParams(){
          return this.$store.getters.getCampaignApiVars;
      },

      count(){
          return this.$store.getters.getCount;
      },

      unit(){
          return this.$store.getters.getUnit;
      },

      display_count() {

        if(typeof this.config.should_redeem !== 'undefined' && !this.config.should_redeem)
          return false;

        return true;
      },

      display_cta() {

        if(typeof this.config.cta_link !== 'undefined' && typeof this.config.cta_text !== 'undefined')
          return true;

        return false;

      }
  },
  created : function(){
    this.$store.commit("SET_APP_LOADING",true);
    this.activateVoucher();
  },
  mounted : function(){
  },
  methods: {
    activateVoucher()
    {
        if(this.config.uniquecode_redeemed){
          this.code = {
            uniquecode : this.config.uniquecode,
            redeemed_at : new Date(this.config.uniquecode_redeemed_at),
            qr_code : this.config.qr_code
          };
          this.redeemed_at = this.code.redeemed_at;
          this.$store.commit("SET_APP_LOADING",false);

          this.showRedeemed();
        }else{

          this.confirm = false;

          let params = this.apiCampaignParams;
          params.q = 'activate-code';
          params.u = this.unit;

          window.axios.post(process.env.VUE_APP_CONTROLLER_URL, params)
          .then(response => {
            this.$store.commit("SET_APP_LOADING",false);
            this.code = response.data;
            this.redeemed_at = new Date(response.data.redeemed_at);
            if(this.display_count) 
              this.doCount();
          });
        }

    },
  
    doCount()
    {
      let x = setInterval(()  => {
        this.$store.commit("SET_COUNT", this.count-1);
        if(this.count==0){
          clearInterval(x);
          this.showRedeemed();
        }
      }, 1000);
    },
    showRedeemed()
    {
        this.redeemed = true;
        this.$store.commit("SET_COUNT", '&#x2714');

        if(this.config.contact_vouchers_amount > 0) {
          this.config.contact_vouchers_amount--;
          this.$store.commit("SET_VOUCHERS_AMOUNT",this.config.contact_vouchers_amount);
        }

    }  
  }
}
</script>

<style lang="scss">

    @keyframes strike{
      0%   { width : 0; }
      100% { width: 80%; }
    }
    .strike {
      position: relative;
    }
    .strike::after {
      margin-left:10%;
      content: ' ';
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 3px;
      margin-top:-3px;
      background: black;
      animation-name: strike;
      animation-duration: 0.5s;
      animation-timing-function: linear;
      animation-iteration-count: 1;
      animation-fill-mode: forwards; 
    }

</style>